var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ELSIcon } from '@els/els-component-form-field-react';
import moment from 'moment';
import { EAQ_TOPIC_REPORT } from 'reports/cw/constants/cw.constant';
import { fetchCatalogs } from 'reports/ps/services/ps.service';
import { KEY_CODES, STUDENT_DETAIL_APP_LINK } from '../constants/app.constant';
var onKeyDownHandler = function (evt, handler) {
    var _a;
    var keyCode = evt.keyCode;
    if (keyCode === KEY_CODES.ENTER || keyCode === KEY_CODES.SPACE) {
        (_a = evt.preventDefault) === null || _a === void 0 ? void 0 : _a.call(evt);
        handler();
    }
};
var pluralizeUnit = function (count, unit) { return "".concat(unit).concat(Math.abs(count) !== 1 ? 's' : ''); };
var pluralizePossessiveUnit = function (count, unit) {
    var base = count === 1 ? unit : "".concat(unit, "s");
    var possessive = count === 1 ? "'s" : "'";
    return "".concat(count, " ").concat(base).concat(possessive);
};
var renderNoDataFound = function (customClass, message) {
    if (message === void 0) { message = 'No data found'; }
    return <p className={"u-els-padding-top-2x u-els-padding-bottom-2x u-els-text-center u-els-italic c-no-data-found ".concat(customClass)}>{"".concat(message || 'No data found', ".")}</p>;
};
var renderNoCourseFound = function () {
    return <p className="u-els-padding-top-2x u-els-padding-bottom-2x u-els-text-center u-els-italic c-no-course-found">Course not found.</p>;
};
var renderNoResultsFound = function (message) {
    return (<p className="u-els-padding-top-2x u-els-padding-bottom-2x u-els-padding-left-1x@mobile u-els-italic u-els-text-center u-els-text-left@mobile c-not-results-found">
      {"".concat(message || 'No results found', ".")}
    </p>);
};
var renderStudentDetailLinkTitle = function (title) {
    return (<span>
      {title}
      <ELSIcon name="new-window" size="1x" customClass="u-els-margin-left-1o2"/>
    </span>);
};
var renderHadStudentDetailLinkTitle = function () { return renderStudentDetailLinkTitle(STUDENT_DETAIL_APP_LINK.HAD.title); };
var renderCwStudentDetailLinkTitle = function () { return renderStudentDetailLinkTitle(STUDENT_DETAIL_APP_LINK.CW.title); };
var renderCwStudentHomeEaqTopicReportTitle = function () { return renderStudentDetailLinkTitle(EAQ_TOPIC_REPORT); };
var ordinalSuffixOf = function (n) {
    var tail = n % 10;
    var hundredTail = n % 100;
    if (tail === 1 && hundredTail !== 11) {
        return "".concat(n, "st");
    }
    if (tail === 2 && hundredTail !== 12) {
        return "".concat(n, "nd");
    }
    if (tail === 3 && hundredTail !== 13) {
        return "".concat(n, "rd");
    }
    return "".concat(n, "th");
};
var getIndexByKeyCode = function (key, currentIndex, max) {
    if (key === KEY_CODES.UP) {
        return currentIndex <= 0 ? max : currentIndex - 1;
    }
    if (key === KEY_CODES.DOWN || key === KEY_CODES.TAB) {
        return currentIndex >= max ? 0 : currentIndex + 1;
    }
    return currentIndex;
};
var getCatalogs = function (courses, allExternalUserInfo, resourceType) { return __awaiter(void 0, void 0, void 0, function () {
    var instructorCourseIds, isbnsByUserId, isbnList, _a, _b, _c, catalog, _d, externalEntities;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                instructorCourseIds = (courses || []).map(function (sc) { return sc.id || sc.courseId; });
                if (!(allExternalUserInfo.length > 0)) return [3 /*break*/, 2];
                isbnsByUserId = allExternalUserInfo
                    .map(function (student) {
                    var isbns = student.courseSections
                        .filter(function (course) { return instructorCourseIds.includes(course.id); })
                        .flatMap(function (course) { return Array.from(new Set(course.entitlements.map(function (etm) { return etm.isbn; }))); });
                    return {
                        studentEolsId: student.id,
                        isbns: isbns
                    };
                })
                    .filter(function (userIsbns) { return userIsbns.isbns.length > 0; });
                isbnList = Array.from(new Set(isbnsByUserId.flatMap(function (userIsbns) { return userIsbns.isbns; })));
                return [4 /*yield*/, fetchCatalogs(isbnList, resourceType)];
            case 1:
                _a = (_e.sent()).data, _b = _a === void 0 ? {} : _a, _c = _b.catalog, catalog = _c === void 0 ? [] : _c, _d = _b.externalEntities, externalEntities = _d === void 0 ? [] : _d;
                return [2 /*return*/, { catalog: catalog, externalEntities: externalEntities, isbnsByUserId: isbnsByUserId }];
            case 2: return [2 /*return*/, { catalog: null, externalEntities: null, isbnsByUserId: null }];
        }
    });
}); };
var convertRangeDates = function (fromDate, toDate) {
    var startDate = moment(fromDate).startOf('day').valueOf().toString();
    var endDate = moment(toDate).endOf('day').valueOf().toString();
    return { startDate: startDate, endDate: endDate };
};
var toTitleCase = function (text) {
    if (!text)
        return '';
    return text.toLowerCase().replace(/\b\w/g, function (char) { return char.toUpperCase(); });
};
export { convertRangeDates, getCatalogs, getIndexByKeyCode, onKeyDownHandler, ordinalSuffixOf, pluralizePossessiveUnit, pluralizeUnit, renderCwStudentDetailLinkTitle, renderCwStudentHomeEaqTopicReportTitle, renderHadStudentDetailLinkTitle, renderNoCourseFound, renderNoDataFound, renderNoResultsFound, renderStudentDetailLinkTitle, toTitleCase };
